import { useQuery } from '@tanstack/react-query'
import { Col, Flex, Row, Spin } from 'antd'

import { Entities_WebFlow_Resources_ResourceItem } from '@suntex.fim/api-client'
import { useFramework } from '@suntex.fim/framework'
import { ResourceItem, ResourceList } from '@suntex.fim/ui'

/**
 * returns JSX for resources
 */
function ResourceCategory({
  title,
  resources = []
}: {
  title: string
  resources: Entities_WebFlow_Resources_ResourceItem[]
}) {
  const resourceItems: ResourceItem[] = resources.map((item) => ({
    title: item.name,
    to: item.pdfLink,
    target: '_blank',
    rel: 'noopener noreferrer'
  }))

  return <ResourceList title={title} resources={resourceItems} />
}
function ResourcesPage() {
  const { api } = useFramework()
  const { data } = useQuery({
    queryKey: ['webflow', 'resources'],
    queryFn: () => api.get_WebFlow_Resources({})
  })
  if (!data) return <Spin />
  const resourceCategories = Object.entries(data).sort(([a], [b]) =>
    a.localeCompare(b)
  )
  const half = Math.ceil(resourceCategories.length / 2)
  const leftColumn = resourceCategories.slice(0, half)
  const rightColumn = resourceCategories.slice(half)
  return (
    <Flex vertical>
      <div className="main-navigation">
        <h3 className="main-navigation__heading">Resources</h3>
      </div>
      <Row className="resources-column-wrapper" gutter={40}>
        <Col className="resources-column" sm={24} md={12}>
          {leftColumn.map(([category, resources]) => (
            <ResourceCategory
              key={category}
              title={category}
              resources={resources}
            />
          ))}
        </Col>
        <Col className="resources-column" sm={24} md={12}>
          {rightColumn.map(([category, resources]) => (
            <ResourceCategory
              key={category}
              title={category}
              resources={resources}
            />
          ))}
        </Col>
      </Row>
    </Flex>
  )
}

export default ResourcesPage
